import React from 'react'
import { ReactComponent as ViettelCloudLogo } from 'assets/icons/ViettelCloudLogo.svg'

export const ViettelCloudIAM = (props) => {

  return (
    <ViettelCloudLogo size={23} />
  )
}
